import script from "./DiagnosticsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticsCard.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosticsCard.vue?vue&type=style&index=0&id=1ab08e5e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab08e5e"]])

export default __exports__